import { privateAxiosIntance } from "../../Config/axios";
import { API_URLS } from "../../Config/urls";

export const getProfileFn = (reqBody) => {
  try {
    const response = privateAxiosIntance.get(API_URLS.profile, {
      params: reqBody,

      headers: {
        Token: localStorage.getItem("token"),
      },
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
